import {
    DIC
} from '@/const/dic'
// import {
//     validateChinese
// } from '@/util/validate'
// import {
//     formatterTime
// } from '@/util/util'



export const depRuleOption = {
    align: "center",
    menuAlign: "center",
    headerAlign: "center",
    border: true,
    expand: false,
    stripe: false,
    showHeader: true,
    // align: 'center',
    index: false,
    selection: true,
    menu: true,
    page: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    columnBtn: false,
    //viewBtn: true,
    menuWidth: '200',
    labelWidth: '150',
    defaultSort: {
        prop: 'createTime',
        order: 'descending'
    },
    column: [{
            label: "部门编号",
            prop: "code",
            type: 'input',
            editVisdiplay:false,
        },
        {
            label: "部门名称",
            prop: "name",
            search:true,
            editVisdiplay:false,
        },
        {
            label: "部门负责人",
            prop: "stuffName",
            editVisdiplay:false,
        },
        {
            label: "部门单次加分上限",
            prop: "transDepartAddMax",
            placeholder: "其他部门负责人针对本部门员工的单次加分上限",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                message: "其他部门负责人针对本部门员工的单次加分上限"
            }]
        },
        {
            label: "部门单次减分上限",
            prop: "transDepartSubMax",
            placeholder: "其他部门负责人针对本部门员工的单次减分上限",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                message: "其他部门负责人针对本部门员工的单次减分上限"
            }]
        },
        {
            label: "员工单次加分上限",
            prop: "departAddMax",
            placeholder: "本部门针对员工的单次加分上限",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                message: "本部门针对员工的单次加分上限"
            }]
        },
        {
            label: "员工单次减分上限",
            prop: "departSubMax",
            placeholder: "本部门针对员工的单次减分上限",
            type: 'input',
            rules: [{
                required: true,
                trigger: "blur",
                message: "本部门针对员工的单次减分上限"
            }]
        },
        {
            label: "更新时间",
            prop: "updateTime",
            type: "datetime",
            // sortable: true,
            valueFormat: "timestamp",
            format: "yyyy-MM-dd HH:mm:ss",
            addVisdiplay: false,
            editVisdiplay: false
        },
        {
            label: "更新人",
            prop: "updateBy",
            type: "input",
            addVisdiplay: false,
            editVisdiplay: false,
            width: "110"
        },
    ]
};